export enum AnimationEntryExit {
    ENTRY = 'ENTRY',
    EXIT = 'EXIT',
}

export enum OverlayId {
    BURGER_MENU = 'BURGER_MENU',
    ACCOUNT_MENU = 'ACCOUNT_MENU',
    LOGIN_AND_REGISTER = 'LOGIN_AND_REGISTER',
    DESKTOP_NAV_FLYOUT = 'DESKTOP_NAV_FLYOUT',
    CATEGORY_FLYOUT = 'CATEGORY_FLYOUT',
    SEARCH_FLYOUT = 'SEARCH_FLYOUT',
    SHOP_TO_CLUB_REGISTRATION_SINGLE_STEP_OVERLAY = 'SHOP_TO_CLUB_REGISTRATION_SINGLE_STEP_OVERLAY',
    SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY = 'SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY',
    DESKTOP_CART_OVERLAY = 'DESKTOP_CART_OVERLAY',
    DESKTOP_ACCOUNT_OVERLAY = 'DESKTOP_ACCOUNT_OVERLAY',
    DESKTOP_HELP_CENTER_OVERLAY = 'DESKTOP_HELP_CENTER_OVERLAY',
    RATE_YOUR_PRODUCT = 'RATE_YOUR_PRODUCT',
    PDP_IMAGE_ZOOM = 'PDP_IMAGE_ZOOM',
    TWO_MAN_HANDLING = 'TWO_MAN_HANDLING',
    FILTERS_FLYOUT = 'FILTERS_FLYOUT',
    ACCOUNT_FLYOUT = 'ACCOUNT_FLYOUT',
    DOUBLE_OPT_IN_OVERLAY = 'DOUBLE_OPT_IN_OVERLAY',
    FABRIC_SAMPLE_OVERLAY = 'FABRIC_SAMPLE_OVERLAY',
}

export type ShopToClubOverlay =
    | typeof OverlayId.SHOP_TO_CLUB_REGISTRATION_SINGLE_STEP_OVERLAY
    | typeof OverlayId.SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY;

export default { AnimationEntryExit };
